import ctl from "@netlify/classnames-template-literals";

export const iconContainer = ctl(`
  h-full
  w-full
`);
